import { render, staticRenderFns } from "./ActionCenterTasksView.vue?vue&type=template&id=85ff5456&"
import script from "./ActionCenterTasksView.vue?vue&type=script&lang=js&"
export * from "./ActionCenterTasksView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports